<div [formGroup]="parts" class="latlang-input-container">
    <!-- Degree Form Field -->
    <input class="latlang-input-element width-30"
           type="number"
           formControlName="degree"
           size="3" 
           aria-label="degree"
           (input)="_handleInput()"
           >
    <span class="latlang-input-spacer">&deg;</span>

    <!-- Minutes Form Field -->
    <input class="latlang-input-element"
           [ngClass]="{'width-30' : coordinateType === 'DMS','width-50' : coordinateType === 'DM'}"
           type="number"
           formControlName="minutes"
           size="3"
           aria-label="Minutes" 
           (input)="_handleInput()"
           >
    <span class="latlang-input-spacer"> &apos;</span>

    <!-- Seconds Form Field -->
    <input *ngIf="coordinateType === 'DMS'"
            class="latlang-input-element width-30"
            type="number"
            formControlName="seconds" 
            size="4" 
            aria-label="Seconds"
            (input)="_handleInput()"
            >
    <span class="latlang-input-spacer"  *ngIf="coordinateType === 'DMS'"> &quot;</span>
  </div>
  
  